<div class="email-loader" role="status" aria-label="Scanning email">
  <svg viewBox="0 0 490 400" aria-hidden="true">
    <defs>
      <g id="mail-shape"
         stroke="#8b97ae"
         stroke-width="2"
         stroke-linecap="round"
         stroke-linejoin="round">
        <rect
          x="85" y="57" width="70" height="46" rx="5"
          fill="#f4f6fa"
        />

        <path
          d="M87 100 L111 79 M153 100 L129 79"
          fill="none"
        />

        <path
          d="M87 60 L116 81 Q120 84 124 81 L153 60"
          fill="none"
        />
      </g>

      <clipPath id="glass-window" clipPathUnits="userSpaceOnUse">
        <circle r="93" />
      </clipPath>
    </defs>

    <g transform="translate(100 100)">
      <!-- Static envelope -->
      <use href="#mail-shape" />

      <g class="scanning-glass">
        <!-- Handle -->
        <path
          d="M72 72 L135 135"
          stroke="#8b97ae"
          stroke-width="30"
          stroke-linecap="round"
        />

        <!-- Magnified view inside the lens -->
        <g clip-path="url(#glass-window)">
          <circle r="93" fill="white" />

          <g class="zoomed-mail">
            <use href="#mail-shape" />
          </g>
        </g>

        <!-- Rim -->
        <circle
          r="96"
          fill="none"
          stroke="#8b97ae"
          stroke-width="12"
        />

        <!-- Reflection -->
        <path
          d="M-66 -24 A69 69 0 0 1 -24 -66"
          fill="none"
          stroke="white"
          stroke-width="9"
          stroke-linecap="round"
          opacity=".9"
        />
      </g>
    </g>
  </svg>
</div>
